import { graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { withAnalyticsClient, withEnv } from '@acorns/web-utils'
import { useRemoteStrings } from '@acorns/web-utils'
import { withFormik } from 'formik'
import { filter } from 'ramda'
import { compose, withHandlers, withProps } from 'recompose'

import { shuffle } from 'utils/array/shuffle'
import withAnalyticsIdentity from 'utils/with-analytics-identity'

import userQuery from '../queries/userQuery.gql'
import { routes } from '../routes'
import earlyClosureReasons from './close-early-account.query.gql'
import {
  handleSubmit,
  mapPropsToValues,
  validationSchema,
} from './form-support'
import { EarlyCancelCTATapped, EarlyClosureReasonScreenViewed } from './segment'

export const makeLabelFallbackFromClosureReason = (str: string) => {
  return (
    str.split('_').join(' ').toLowerCase().charAt(0).toUpperCase() +
    str.toLowerCase().slice(1).replace(/\_/g, ' ')
  )
}

const generateReasons = (reasonsEnums, getString) => {
  return reasonsEnums?.map((reason) => {
    const item = {}
    const label =
      getString({
        key: `close_account.early.closure_reasons.${reason.toLowerCase()}`,
      }) || makeLabelFallbackFromClosureReason(reason)

    item.value = reason
    item.label = label
    return item
  })
}
export const enhance = compose<IProps, {}>(
  withEnv,
  withAnalyticsClient,
  withRouter,
  withProps(() => ({
    isWebView: window.location.pathname.startsWith('/wv/'),
  })),
  graphql(userQuery),
  withAnalyticsIdentity,
  graphql(earlyClosureReasons, { name: 'closureReasons' }),
  withProps<any, any>(({ data, isWebView, closureReasons, analytics }) => {
    if (!data.loading) {
      analytics.track('Screen Viewed', EarlyClosureReasonScreenViewed)
    }

    const reasons = closureReasons.earlyAccountClosureReasons
    const { getRemoteString } = useRemoteStrings()

    const earlyRoutes = routes.early

    const values = generateReasons(reasons, getRemoteString) || []

    const shuffledReasons = filter(
      (reason: IReason) => reason.value !== 'OTHER',
    )(shuffle(values))

    shuffledReasons.push({
      label: 'Other',
      value: 'OTHER',
    })
    const backOverride = isWebView
      ? '/wv/my-subscription'
      : '/settings/my-subscription'

    return {
      shuffledReasons,
      backOverride,
      earlyRoutes,
    }
  }),
  withFormik({
    mapPropsToValues,
    validationSchema,
    handleSubmit,
  }),

  withHandlers({
    handleReasonChange:
      ({ setFieldValue }) =>
      (field, value) => {
        setFieldValue(field, value)
      },
    handleCancelSelect:
      ({ history, isWebView, analytics }) =>
      () => {
        analytics.track('Button Tapped', EarlyCancelCTATapped)
        const url = isWebView
          ? '/wv/my-subscription'
          : '/settings/my-subscription'
        history.push(url)
      },
  }),
)
